import moment from "moment";

export default {
  setScheduleBoardFilters({ commit, state }, data) {
    commit("update", {
      state: "scheduleBoardFilters",
      data,
    });
    // Cache filters
    let filterCache = { ...state.scheduleBoardFilters, ...data };
    // Don't cache start if it is today
    // prevents bug of scheduler starting stuck on yesterday
    if (moment().isSame(filterCache.start, "day")) {
      delete filterCache.start;
    }
    localStorage.setItem("scheduleBoardFilters", JSON.stringify(filterCache));
  },
  assignDraggedAppointment(_, data) {
    const { appointmentId, ...apiParams } = data;

    // FIXME: should use API.makeRequest instead of ajax
    // this api endpoing authentication needs to be updated in the backend
    return new Promise((resolve, reject) => {
      $.ajax(`/appointments_calendar/${appointmentId}/set_tech`, {
        method: "PUT",
        data: apiParams,
        success: resolve,
        error: reject,
      });
    });
  },
};
